import React from 'react';
import './Progress.scss';

interface ProgressProps {
  currentSlide: number;
  fromSlides: number;
  hideLabel?: boolean;
}

const Progress: React.FC<ProgressProps> = ({currentSlide, fromSlides, hideLabel}) => {
  return <div className="progress">
      {[...Array(currentSlide)].map((e, i) => <span className="full" key={`progress-full-${i}`} />)}
      {[...Array(fromSlides - currentSlide)].map((e, i) => <span key={`progress-empty-${i}`} />)}    
      { !hideLabel && <p className={'handwrite'}>Question {currentSlide}</p>}
  </div>;
};

export default Progress;